module.exports = __webpack_public_path__ + "assets/images/extra_man2.017cff29ddc6460becbf718d9b99caf7.svg";